import { render, staticRenderFns } from "./DmPreislisteChat.vue?vue&type=template&id=6b623a1f&scoped=true&"
import script from "./DmPreislisteChat.vue?vue&type=script&lang=js&"
export * from "./DmPreislisteChat.vue?vue&type=script&lang=js&"
import style0 from "./DmPreislisteChat.vue?vue&type=style&index=0&id=6b623a1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b623a1f",
  null
  
)

export default component.exports